<div class="tw-mb-2">
  <bit-search
    [placeholder]="'search' | i18n"
    [(ngModel)]="searchText"
    (ngModelChange)="onSearchTextChanged()"
    appAutofocus
  >
  </bit-search>
</div>
